<script lang="ts">
	import { isItBot } from "$lib/helpers";
	import { onMount } from "svelte";

	export let noBots = false;
	let show = true;
	
	onMount(() => {
		show = !noBots || (noBots && !isItBot());
	});
 
</script>

{#if typeof window !== "undefined" && show}
   <slot/>
{/if}